import { Dialog } from '@base-ui/react';
import cx from 'classnames';
import { type ReactNode, useRef } from 'react';
import styles from './Drawer.scss';

export const Drawer = (
  props: Dialog.Root.Props & {
    side: 'left' | 'right';
    trigger?: Dialog.Trigger.Props['render'];
    drawerContentClassName?: string;
  } & { children: ReactNode },
) => {
  const {
    children,
    side,
    trigger,
    drawerContentClassName,
    ...dialogRootProps
  } = props;
  // By default, the Dialog's initial focus is on the first focusable element
  // inside the dialog. In some cases (e.g. a Close button), this isn't a good
  // choice. Setting the initial focus to the drawer itself avoids this problem.
  const drawerRef = useRef<HTMLDivElement>(null);

  const popupClasses = cx({
    [styles.drawer]: true,
    [styles.left]: side === 'left',
    [styles.right]: side === 'right',
  });

  return (
    <Dialog.Root {...dialogRootProps}>
      {trigger && <Dialog.Trigger render={trigger} />}
      <Dialog.Portal>
        <Dialog.Popup
          className={popupClasses}
          initialFocus={drawerRef}
          ref={drawerRef}
        >
          <div className={cx(styles.drawerContent, drawerContentClassName)}>
            {children}
          </div>
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
